import React, { useState } from 'react'
import './Chats.css'
import MessageScreenHeader from '../../../components/MessageScreenHeader/MessageScreenHeader'
import MessageScreenBody from '../../../components/MessageScreenBody/MessageScreenBody'
import MessageScreenFooter from '../../../components/MessageScreenFooter/MessageScreenFooter'
import { chatSelector } from '../../../../../../store/selector'
import { connect } from 'react-redux'
import ChatNotSelected from '../../../components/ChatNotSelected/ChatNotSelected'
import BodyRender from './BodyRender'


function Chats({ selectedAssignedList }) {
  // const [dispose, setDispose] = useState(false);
  // const [activeTab, setActiveTab] = useState("reply");

  // const renderBody = (selectedAssignedList) => {
  //   if(typeof selectedAssignedList === 'object' && Object.keys(selectedAssignedList).length > 0 ){
  //     return <ChatNotSelected />
  //   } else {
  //     return (
  //       <React.Fragment>
  //         <MessageScreenHeader className="chats__msg-screen-header" />
  //         <MessageScreenBody className="chats__msg-screen-body"/>
  //         <MessageScreenFooter />
  //       </React.Fragment>
  //     )
  //   }
  // }
  return (
    <div className='chats__main'>
      {/* <Body selectedAssignedList={selectedAssignedList} /> */}
      {/* {renderBody(selectedAssignedList)} */}
      <BodyRender selectedAssignedList={selectedAssignedList}
        // dispose={dispose}
        // activeTab={activeTab}
        // setDispose={setDispose}
        // setActiveTab={setActiveTab}
      />
      {/* <MessageScreenHeader className="chats__msg-screen-header" />
      <MessageScreenBody className="chats__msg-screen-body"/>
      <MessageScreenFooter /> */}
    </div>
  )
}

const stateToProps = state => ({
  selectedAssignedList: chatSelector.getChatDynamic(state, 'selectedAssignedList')
});
export default connect(stateToProps)(Chats);


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/modules/middleContent/Chats/index.js